import { RfidRuleServiceInterface} from "interfaces/rfidRule-service.ts";
import { BaseBusinessService } from "services/mms/external-api/business/base-business-service"
import { BackendSchema } from "layouts/charging-rules/interface/Rules.ts"

export class BusinessRfidRuleService
    extends BaseBusinessService
    implements RfidRuleServiceInterface
{

    useGetRfidCardRule = (rfid_id: string): FetchApiProps => {
        return this.get({ endpoint: '/' + rfid_id })
    }

    useUpdateRfidCardRule = (rfid_id: string, rfid_rule: BackendSchema): FetchApiProps => {
        return this.post({ endpoint: '/' + rfid_id, options: { body: rfid_rule }})
    }
}
